import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@shared/data-access';

@Pipe({
  name: 'hasOrganizationRole',
})
export class HasOrganizationRolePipe implements PipeTransform {
  private readonly organizationRoles: UserRole[] = [
    UserRole.BrandAccountOwner,
    UserRole.DistributorAccountOwner,
    UserRole.MerchantAccountOwner,
  ];

  transform(userRoles: UserRole[]): boolean {
    return this.organizationRoles.some((role) => userRoles.includes(role));
  }
}
